<div class="container">
  <div class="title-and-logo">
    <div class="logo-wrapper">
      <img [src]="" />
    </div>
    <div class="logo-wrapper">
      <a [routerLink]="this.routingService.lpHoldingsPage" routerLinkActive="active">
        <img [src]="covercyLogo" />
      </a>
    </div>
  </div>

  <nav>
    <ng-container>
      <a [routerLink]="this.routingService.lpHoldingsPage" routerLinkActive="active"
        (click)="forceReloadOnSamePage(this.routingService.lpHoldingsPage)">My Portfolio</a>

      <a *ngIf="!this.isViewingAsInvestor" [routerLink]="routingService.lpBankAccounts" routerLinkActive="active"
        (click)="forceReloadOnSamePage(routingService.lpBankAccounts)">Bank Accounts</a>

        <a *ngIf="!this.isViewingAsInvestor" [routerLink]="routingService.lpDocuments" routerLinkActive="active"
        (click)="forceReloadOnSamePage(routingService.lpDocuments)">Documents</a>
    </ng-container>
  </nav>

  <terra-account-actions (onAction)="share()"></terra-account-actions>

</div>
